module.exports = __webpack_public_path__ + "img/13.e1ea113e.jpg";